<template>
  <div class="bg-gray-4">
    <div
      class="flex max-md:flex-col md:gap-10 justify-between items-center md:!py-28 py-10 container"
    >
      <div class="flex flex-col max-md:text-center md:max-w-sm gap-8 z-10">
        <h1 class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
          <span class="block">
            {{ t("discover.noActivities") }}
          </span>
          <span class="block">
            {{ name }}
          </span>
        </h1>
        <span class="md:text-paragraph-1 text-mobile-paragraph-1 text-gray-1">
          {{ t("discover.noActivitiesDescription") }}
        </span>
        <SearchBoxOneThree class="md:!w-full mx-auto" />
      </div>

      <NuxtImg
        loading="lazy"
        src="https://tw028jd0.turpal.com/assets/discover-no-activity.svg"
        class="max-md:mt-[75px] w-[450px]"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { ITopCities } from "../../types/general";
import type { PropType } from "vue";

const { t } = useI18n();

defineProps({
  name: { type: String, required: true },
  popularCities: { type: Array as PropType<ITopCities[]>, required: true },
});
</script>
